// src/pages/Login.js
import React from 'react';
import LoginForm from '../components/auth/LoginForm';

export default function Login() {
  const currentYear = new Date().getFullYear();
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-100 via-emerald-50 to-white flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-5xl">
        <div className="bg-white/80 backdrop-blur-xl shadow-2xl rounded-3xl overflow-hidden border border-emerald-100/60 flex flex-col lg:flex-row">
          <div className="lg:w-1/2 bg-gradient-to-br from-emerald-400 via-emerald-500 to-emerald-600 text-white px-10 py-12 flex flex-col justify-between">
            <div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
                  <img
                    src="/logo.png"
                    alt="ATA Service Admin logo"
                    className="w-10 h-10 object-contain"
                  />
                </div>
                <span className="text-2xl font-semibold tracking-wide">ATA Online Services Admin</span>
              </div>
              <h1 className="text-4xl font-bold mt-10 mb-4 leading-tight">Welcome back</h1>
              <p className="text-emerald-50/90 text-lg max-w-sm">
                Manage deliveries, track performance, and keep your operations running smoothly from one modern admin
                dashboard.
              </p>
            </div>
            <div className="mt-10">
              <div className="relative">
                <div className="absolute -inset-4 bg-emerald-300/30 blur-3xl rounded-full" aria-hidden="true" />
                <div className="relative bg-white/10 backdrop-blur-md border border-white/30 rounded-2xl p-6 flex flex-col items-center text-center shadow-lg shadow-emerald-900/20">
                  <div className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center text-4xl mb-4">
                    🛵
                  </div>
                  <p className="text-sm text-emerald-50/80">
                    Empowering your delivery fleet with actionable insights and real-time visibility.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2 p-6 sm:p-10 lg:p-12 bg-white">
            <LoginForm />
          </div>
        </div>
        <p className="mt-6 text-center text-sm text-emerald-700">
          © {currentYear} Powered by Bagavaan Groups | ATA Services
        </p>
      </div>
    </div>
  );
}
